import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui';
import router from './router'
import store from './store'
import qs from "qs";
import jwt_decode from "jwt-decode";
let loading //定义loading变量



function startLoading() { //使用Element loading-start 方法
  return;
  loading = Loading.service({
    lock: true,
    text: '加载中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading() { //使用Element loading-close 方法
  return;
  loading.close()
}
/*判断token是否过期*/
function isTokenExpired() {
  /*从localStorage中取出token过期时间*/
  try {
    let expiredTime = new Date(store.getters.user.exp).getTime()

    /*获取本地时间*/
    let nowTime = new Date().getTime() / 1000
    console.log(expiredTime - nowTime)
    return (expiredTime - nowTime) < 30 * 60
  } catch (error) {
    console.log("error = ", error)
  }
}
/*是否有请求正在刷新token*/
window.isRefreshing = false
// 挂起的请求数组
let refreshSubscribers = []

/*push所有请求到数组中*/
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
function onRrefreshed(token) {
  refreshSubscribers.map(cb => cb(token))
}

function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

// 请求拦截  设置统一header
axios.interceptors.request.use(config => {
  // 加载
  startLoading()
  if (localStorage.chkFaceToken004)
    config.headers.checkfaceauthorization = "BearerCheckFace " + localStorage.chkFaceToken004
  if (localStorage.eleTokenWrd001)
    config.headers.Authorization = "Bearer " + localStorage.eleTokenWrd001
  try {
    if (isTokenExpired() && config.url.indexOf("/api/auth/") === -1&& config.url.indexOf("/api/users/findMeByCardId") === -1&& config.url.indexOf("/api/examRecords/getFormalQuestionInfo") === -1&& config.url.indexOf("/api/students/testPapers") === -1&& config.url.indexOf("/api/signUpOrders") === -1&& config.url.indexOf("/api/courseTypes") === -1&& config.url.indexOf("/api/bigCourseTypes") === -1) {
      console.log("token is Expired,", window.isRefreshing);
      if (!window.isRefreshing) {
        /*将刷新token的标志置为true*/
        window.isRefreshing = true
        /*发起刷新token的请求*/
        get('/api/auth/me').then(res => {
          window.isRefreshing = false
          const {
            token
          } = res.data;
          localStorage.setItem("eleTokenWrd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          store.dispatch("setIsAutnenticated", !isEmpty(decode));
          store.dispatch("setUser", decode);
          /*执行数组里的函数,重新发起被挂起的请求*/
          onRrefreshed(token)
          /*执行onRefreshed函数后清空数组中保存的请求*/
          refreshSubscribers = []
        }).catch(err => {
          /*清除本地保存的auth*/
          // localStorage.removeItem('auth')
          console.log(err)
          window.isRefreshing = false
          router.push('/login');
        })
      }
      let retry = new Promise((resolve, reject) => {
        /*(token) => {...}这个函数就是回调函数*/
        subscribeTokenRefresh((token) => {
          config.headers.Authorization = "Bearer " + token
          /*将请求挂起*/
          resolve(config)
        })
      })
      return retry
    }
  } catch (err) {
    console.log(err)
  }

  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截  401 token过期处理
axios.interceptors.response.use(response => {
  endLoading()
  return response
}, error => {
  // 错误提醒
  endLoading()
  Message.error(error.response.data.error)

  const {
    status
  } = error.response
  if (status == 401) {
    Message.error('身份已过期，请重新登录')
    // 清除token
    localStorage.removeItem('eleTokenWrd001')

    // 页面跳转
    router.push('/login')
  }

  return Promise.reject(error)
})

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    let httpService = axios.create({
      //baseURL: window.api.url,
      timeout: 600000,
      responseType: `json`,
      transformRequest: [data => qs.stringify(data)],
      headers: {
        "Conten-Type": `appplication/x-www-form-urlencoded;charset=utf-8`,
        "Authorization": "Bearer " + localStorage.eleTokenWrd001
      }

    });
    httpService({
        url: url,
        method: `get`,
        params: params

      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
export default axios